import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/components/LanguageContext";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

const Branchen = () => {
  const { t } = useLanguage();
  return (
    <section id="branchen" className="bg-dark py-20 lg:py-32">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-16">
        <Reveal>
          <Eyebrow>{t.branchen.eyebrow}</Eyebrow>
        </Reveal>
        <div className="mt-4 flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
          <Reveal delay={0.08}>
            <h2 className="max-w-xl font-display text-4xl font-medium tracking-tight sm:text-5xl">{t.branchen.title}</h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="max-w-md text-base leading-relaxed text-inkmuted">{t.branchen.sub}</p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-x-16 lg:grid-cols-2">
          {t.branchen.items.map((name, i) => (
            <motion.button
              key={name}
              data-testid={`branchen-tile-${i + 1}`}
              onClick={() => scrollToId("kontakt")}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1, margin: "0px 0px 120px 0px" }}
              transition={{ duration: 0.6, delay: (i % 2) * 0.07, ease: [0.22, 1, 0.36, 1] }}
              className="group -mx-4 flex items-center justify-between gap-6 border-t border-bone/10 px-4 py-7 text-left transition-colors duration-300 hover:bg-goldsoft/40 sm:py-8"
            >
              <div className="flex items-baseline gap-5 sm:gap-8">
                <span className="font-mono text-xs text-gold">[{String(i + 1).padStart(2, "0")}]</span>
                <h3 className="font-display text-2xl font-medium tracking-tight transition-transform duration-300 group-hover:translate-x-2 sm:text-3xl">
                  {name}
                </h3>
              </div>
              <ArrowUpRight
                size={22}
                className="text-bone/25 transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-gold"
              />
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Branchen;
